export const BRAND_PRESETS = {
    statamicBlue: {
        main:   '#3B82F6',
        hover:  '#2563EB',
        active: '#1D4ED8',
        tint:   '#EFF6FF',
        on:     '#FFFFFF',
    },
    desaturatedGreen: {
        main:   '#5A8A3E',
        hover:  '#4A7A2E',
        active: '#3A6A1E',
        tint:   '#F1F6EB',
        on:     '#FFFFFF',
    },
    forestGreen: {
        main:   '#16A34A',
        hover:  '#15803D',
        active: '#166534',
        tint:   '#F0FDF4',
        on:     '#FFFFFF',
    },
    nofamLegacy: {
        main:   '#84BA3F',
        hover:  '#6FA032',
        active: '#5A8525',
        tint:   '#F5FAED',
        on:     '#FFFFFF',
    },
    indigo: {
        main:   '#6366F1',
        hover:  '#4F46E5',
        active: '#4338CA',
        tint:   '#EEF2FF',
        on:     '#FFFFFF',
    },
    slate: {
        main:   '#0F172A',
        hover:  '#1E293B',
        active: '#020617',
        tint:   '#F1F5F9',
        on:     '#FFFFFF',
    },
};

export const BRAND = BRAND_PRESETS.nofamLegacy;
